export interface SessionCtx {
  token: string | null;
  // El shape del payload es responsabilidad del back — el cliente no valida
  // tipos ni presencia. Todo lo que venga en el JWT queda como llego (o null
  // si el campo no esta). Consumidores coercionan con `String(...)` al mandar
  // al back.
  unidad: any;
  anexoId: any;
  usuario: any;
}

export const EMPTY_SESSION: SessionCtx = {
  token: null,
  unidad: null,
  anexoId: null,
  usuario: null,
};

// Solo validamos que sea un JWT parseable — 2+ partes, segundo segmento
// base64 con payload JSON. No miramos shape del payload. Si el token esta
// roto (sin `.`, base64 invalido, JSON invalido), devolvemos EMPTY_SESSION y
// la app cae al flujo publico.
export function parseSessionToken(raw: string | null | undefined): SessionCtx {
  if (!raw) return EMPTY_SESSION;
  try {
    const parts = raw.split('.');
    if (parts.length < 2) return EMPTY_SESSION;
    const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = b64 + '==='.slice((b64.length + 3) % 4);
    const json = JSON.parse(atob(padded));
    const payload = json ?? {};
    return {
      token: raw,
      unidad: payload.unidad ?? null,
      anexoId: payload.anexoId ?? null,
      usuario: payload.usuario ?? null,
    };
  } catch {
    return EMPTY_SESSION;
  }
}
